export const setIconState = (state, toggler, hiddenIcon, expandedIcon) => {
  if (state === 'open') {
    toggler.classList.add(expandedIcon);
    toggler.classList.remove(hiddenIcon);
  } else {
    toggler.classList.add(hiddenIcon);
    toggler.classList.remove(expandedIcon);
  }
};
